module.exports = __webpack_public_path__ + "static/media/normal-empty.2d2539b9.png";